import {
  EntityEntry,
  EntityFeatureName,
  EntityFeatureNameEnum,
  EntityStore,
  EntityStoreEnum,
  SelectState
} from "@shared/contracts/entity-store.contract";
import {InAppNotificationLogType} from "@generated/graphql";
import {InjectionToken, Provider} from "@angular/core";
import {InAppNotificationLog} from "@modules/in-app-notification-log/models/in-app-notification-log.model";

export class InAppNotificationLogStore extends EntityStore<EntityFeatureNameEnum.InAppNotificationLog, InAppNotificationLogType, InAppNotificationLog> {
  get selectState(): SelectState<InAppNotificationLogType> {
    return this.feature.selectInAppNotificationLogFeatureState;
  }

  getEntry(): EntityEntry<EntityFeatureNameEnum.InAppNotificationLog> {
    return 'IN_APP_NOTIFICATION_LOG';
  }

  getFeatureName(): EntityFeatureName<EntityFeatureNameEnum.InAppNotificationLog> {
    return 'inAppNotificationLogFeature';
  }
}

export const inAppNotificationLogStore = new InAppNotificationLogStore()

export const IN_APP_NOTIFICATION_LOG_STORE = new InjectionToken<EntityStoreEnum>(EntityStoreEnum.InAppNotificationLogStore)

export const IN_APP_NOTIFICATION_LOG_STORE_CONFIG: Provider = {
  provide: IN_APP_NOTIFICATION_LOG_STORE,
  useValue: inAppNotificationLogStore,
}
